import { ILoginCustomer } from "../../common/models/LoginCustomer";
import LoginViewUtils from "../../views/login-view/LoginViewUtils";
import restService from "../rest-service/RestService";
import storageService from "../storage/storage-service/StorageService";

const CUSTOMER_CACHE_STORAGE_KEY = "elynx.user.accessiblecustomers";

const CustomerDataService = {

    // getCustomers: async function(accessKey: string): Promise<ICustomerLoginModel[]> {

    //     try {
    //         const response = await restService.get<ICustomerLoginModel[]>("/customerlist");
    //         return response.data;

    //     } catch(error) {
    //         //@@wonder if we can config axios to call generic error handler
    //         throw error;
    //     }
    // },

    cacheCustomerList: function(customers: ILoginCustomer[]): void {
        storageService.local.set<ILoginCustomer[]>(CUSTOMER_CACHE_STORAGE_KEY, customers);
    },
    getCustomerList: async function(reload?: boolean, abortSignal?: AbortSignal): Promise<ILoginCustomer[]> {

        if (reload) {
            const mfaTokens = LoginViewUtils.getMfaTokens()?.map(token => token.Value)?.join(";") ?? "";
            const queryParams = {
                mfaTokens: mfaTokens
            }

        const response = await restService.get<ILoginCustomer[], { mfaTokens: string}>("customers", abortSignal, queryParams);
            return response.data;

        }
        return storageService.local.get<ILoginCustomer[]>(CUSTOMER_CACHE_STORAGE_KEY, []);
    }



};

export default CustomerDataService;